import Model from "../Model";
//TODO: Try to resolve issues with exntending from vue-components instead of local copy
//import Model from './components/vue-components/src/models/Model';

export default class CvUploadModel extends Model {
    constructor({uploadedById, brand, source, externalId, forJobId, file} = {}) {
        super();

        this.addField({
            name: 'brand',
            value: brand || '',
            validation: {
                required: true
            }
        });

        this.addField({
            name: 'source',
            value: source || '',
            validation: {
                required: true
            }
        });

        this.addField({
            name: 'forJobId',
            value: forJobId || ''
        });

        this.addField({
            name: 'externalId',
            value: externalId || '',
            validation: {
                length: 18
            }
        });

        this.addField({
            name: 'uploadedById',
            value: uploadedById || '',
            validation: {
                required: true
            }
        });

        this.addCollection({
            name: 'cvFiles',
            description: 'document',
            validation: {
                required: true
            }
        });

    }
}